import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RegisterActivation from '../login/RegisterActivation';
import Login from '../login/Login';
import ResetPassword from '../login/ResetPassword';
import ResetPasswordRequest from '../login/ResetPasswordRequest';
import PreRegister from '../login/PreRegister';
import Register from '../login/Register';
import RegisterAccept from '../login/RegisterAccept';
import DatabaseBeingCreated from '../login/DatabaseBeingCreated';
import ChangeEmail from '../login/ChangeEmail';
import DocumentAccess from '../document/DocumentAccess';

const RouterExternal = () => (
  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/login" element={<Login />} />
    <Route path="/pre-register" element={<PreRegister />} />
    <Route path="/customer/resend-activation/:cEmail" element={<PreRegister />} />
    <Route path="/customer/register/:cToken" element={<Register />} />
    <Route path="/customer/accept/:cToken" element={<RegisterAccept />} />
    <Route path="/database/create/:cToken?" element={<DatabaseBeingCreated />} />
    <Route path="/reset-password" element={<ResetPasswordRequest />} />
    <Route path="/reset-password/:cToken" element={<ResetPassword />} />
    <Route path="/reset-email/:cToken" element={<ChangeEmail />} />
    <Route path="/register/activate/:cToken" element={<RegisterActivation />} />
    <Route path="/register/resend-activation/:cEmail" element={<RegisterActivation />} />
    <Route path="/document-share/:hash" element={<DocumentAccess />} />
    <Route path="*" element={<Login />} />
  </Routes>
);

export default RouterExternal;
